import { render, staticRenderFns } from "./NotificationPreferences.vue?vue&type=template&id=1107f4ae&"
import script from "./NotificationPreferences.vue?vue&type=script&lang=js&"
export * from "./NotificationPreferences.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPreferences.vue?vue&type=style&index=0&id=1107f4ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports